module.exports = __webpack_public_path__ + "static/media/groceryAvatar.2a62df8c.svg";